export type AgTechSideNavigationAppLogoProps = {
    appIcon: string,
    appName: string,
    isCollapsed: boolean
}

const AgTechSideNavigationAppLogo = (props: AgTechSideNavigationAppLogoProps) => {
    const backgroundColor = props.isCollapsed ? 'bg-secondary' : 'bg-appSideNav';

    return (
        <div className={`h-[55px] centered text-2xl font-orbitron text-appSideNavFont ${backgroundColor} div`}>
            {props.isCollapsed ? (
                <i className={`text-appSideNavFont w-[29px] text-xl ${props.appIcon}`} />
            ) : props.appName}
        </div>
    )
}

export default AgTechSideNavigationAppLogo;